import { IDiscipline } from "../../constants/courses/IDiscipline";
import { useTranslation } from "react-i18next";
import { API } from "@brg/api";
import { useMemo } from "react";

export const useGetDisciplinesTabsFromDisciplines = (disciplines: IDiscipline<'Global'>[]) => {

    const { i18n } = useTranslation()

    const tabs = useMemo(() => {
        const disciplineTabs = disciplines.map((discipline) => ({
            path: discipline.id,
            name: discipline.name,
            entityType: 'modules',
            filter: {
                contexts: discipline.id
            }
        }))

        return API.toLang(disciplineTabs, i18n.language) as IDiscipline<'Global'>[]
    }, [disciplines, i18n.language])

    return tabs
}import { IDiscipline } from "../../constants/courses/IDiscipline";
import { useTranslation } from "react-i18next";
import { API } from "@brg/api";
import { useMemo } from "react";

export const useGetDisciplinesTabsFromDisciplines = (disciplines: IDiscipline<'Global'>[]) => {

    const { i18n } = useTranslation()

    const tabs = useMemo(() => {
        const disciplineTabs = disciplines.map((discipline) => ({
            path: discipline.id,
            name: discipline.name,
            entityType: 'modules',
            filter: {
                contexts: discipline.id
            }
        }))

        return API.toLang(disciplineTabs, i18n.language) as IDiscipline<'Global'>[]
    }, [disciplines, i18n.language])

    return tabs
}